import React, { useState } from 'react';
import './Certificates.css';

const certificates = [
  { title: 'Huawei', image: 'https://i.imgur.com/n821pTU.png' },
  { title: 'Huawei', image: 'https://i.imgur.com/gvdMN50.png' },
  { title: 'Huawei', image: 'https://i.imgur.com/mTprQj2.png' },
  { title: 'Cisco', image: 'https://i.imgur.com/ebe9pOP.png' },
  { title: 'TESDA', image: 'https://i.imgur.com/0BdpOhr.jpeg' },
];

function Certificates() {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleView = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <section id="certificates" className="certificates-section">
        <h1>Certificates</h1>
        <div className="certificates-grid">
          {certificates.map((cert, index) => (
            <div className="certificate-card" key={index}>
              <img src={cert.image} alt={cert.title} />
              <div className="certificate-title">{cert.title}</div>
              <button className="view-btn" onClick={() => handleView(cert.image)}>
                View
              </button>
            </div>
          ))}
        </div>
      </section>

      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>✖</button>
            <img src={selectedImage} alt="Enlarged Certificate" />
          </div>
        </div>
      )}
    </>
  );
}

export default Certificates;
